import { useMemo } from 'react';
import { DayDataProvider } from './DayDataProvider';
import { HourDataProvider } from './HourDataProvider';
import { ReportGran } from 'core/report/ReportData';
import { DeliveryUnit } from 'core/channelGroup/ChannelGroup';

export const useOutdoorDeviceReportDataProvider = (
  gran: ReportGran,
  deliveryUnit?: DeliveryUnit
) => {
  const dataProvider = useMemo(() => {
    if (gran === ReportGran.DAY) {
      return new DayDataProvider(deliveryUnit);
    }
    return new HourDataProvider(deliveryUnit);
  }, [gran, deliveryUnit]);

  return dataProvider;
};
